import React, { FunctionComponent, PropsWithChildren, useState } from 'react'
import { Accordion, Text, Flex } from '@afterpaytouch/core'
import { useCheckoutSizes } from '../../../../../utils/responsive'
import type { Money as MoneyType } from '@afterpay/types'
import styles from './style.module.css'
import { Money } from '../../../../../component'

type GroupContainerProps = {
  name: string
  amount: MoneyType
  expandable?: boolean
  testNameSpace?: string
}

export const GroupContainer: FunctionComponent<PropsWithChildren<GroupContainerProps>> = (props): JSX.Element => {
  const { name, amount, children, expandable = false, testNameSpace = '' } = props
  const [isOpen, setIsOpen] = useState(false)
  const { textSize } = useCheckoutSizes()

  const childrenCount = React.Children.count(children)

  if (!expandable) {
    return (
      <Flex direction='column'>
        <Flex fullWidth justifyContent='space-between'>
          <Text size={textSize} bold testNameSpace={`summary-group-container-${testNameSpace}`}>
            {name}
          </Text>
          {childrenCount === 0 && <Money value={amount} size={textSize} bold />}
        </Flex>
        {childrenCount > 0 && <div className={styles.container}>{children}</div>}
      </Flex>
    )
  }

  return (
    <Accordion expanded={isOpen} onChange={setIsOpen}>
      <Accordion.Button>
        <Flex justifyContent='space-between'>
          <Text size={textSize} bold testNameSpace={`summary-group-container-${testNameSpace}`}>
            {name}
          </Text>
          {!isOpen && <Money value={amount} size={textSize} bold />}
        </Flex>
      </Accordion.Button>
      <Accordion.Details>{children}</Accordion.Details>
    </Accordion>
  )
}
